(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var page = document.getElementById("bqa-lc-page");
    if (!page) return;

    var catalog = window.BQA_LEARNING_CENTER_COURSES || {};
    var pathKey = page.dataset.pathKey;
    var currentId = page.dataset.currentLesson;
    var course = catalog[pathKey];

    if (!course) {
      console.error("BQA Learning Center: no course found for path key:", pathKey);
      return;
    }

    function byId(id) { return document.getElementById(id); }
    function setText(id, text) {
      var el = byId(id);
      if (el && text != null) el.textContent = text;
    }

    var allLessons = [];
    course.modules.forEach(function (module, moduleIndex) {
      module.lessons.forEach(function (lesson, lessonIndex) {
        allLessons.push(Object.assign({
          moduleTitle: module.title,
          moduleId: module.id,
          moduleIndex: moduleIndex,
          lessonIndex: lessonIndex
        }, lesson));
      });
    });

    var publishedLessons = allLessons.filter(function (lesson) { return lesson.published !== false; });
    var currentIndex = publishedLessons.findIndex(function (lesson) { return lesson.id === currentId; });
    var currentLesson = allLessons.find(function (lesson) { return lesson.id === currentId; }) || null;

    function readProgress() {
      try { return JSON.parse(localStorage.getItem(course.storageKey)) || {}; }
      catch (e) { return {}; }
    }

    function saveProgress(value) {
      try { localStorage.setItem(course.storageKey, JSON.stringify(value)); }
      catch (e) { console.warn("BQA Learning Center: progress could not be saved.", e); }
    }

    function readModuleState() {
      try { return JSON.parse(localStorage.getItem(course.storageKey + "-modules")) || {}; }
      catch (e) { return {}; }
    }

    function saveModuleState(value) {
      try { localStorage.setItem(course.storageKey + "-modules", JSON.stringify(value)); }
      catch (e) { /* noncritical */ }
    }

    var progress = readProgress();
    var moduleState = readModuleState();

    function moveDrawerToBody() {
      var overlay = byId("bqa-lc-drawer-overlay");
      var drawer = byId("bqa-lc-course-drawer");
      if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
      if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    }

    function modulePublishedCount(module) {
      return module.lessons.filter(function (lesson) { return lesson.published !== false; }).length;
    }

    function moduleCompletedCount(module) {
      return module.lessons.filter(function (lesson) {
        return lesson.published !== false && !!progress[lesson.id];
      }).length;
    }

    function renderCourseNavigation() {
      var nav = byId("bqa-lc-course-nav");
      if (!nav) return;
      nav.innerHTML = "";

      course.modules.forEach(function (module) {
        var section = document.createElement("section");
        section.className = "bqa-lc-module";

        var containsCurrent = module.lessons.some(function (lesson) { return lesson.id === currentId; });
        var isOpen = moduleState[module.id];
        if (typeof isOpen !== "boolean") isOpen = containsCurrent;

        var toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "bqa-lc-module-toggle";
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");

        var chevron = document.createElement("span");
        chevron.className = "bqa-lc-module-chevron";
        chevron.setAttribute("aria-hidden", "true");
        chevron.textContent = "▶";

        var heading = document.createElement("span");
        heading.className = "bqa-lc-module-title";
        heading.textContent = module.title;

        var count = document.createElement("span");
        count.className = "bqa-lc-module-count";
        count.textContent = moduleCompletedCount(module) + "/" + modulePublishedCount(module);

        toggle.appendChild(chevron);
        toggle.appendChild(heading);
        toggle.appendChild(count);

        var panel = document.createElement("div");
        panel.className = "bqa-lc-module-panel";
        panel.hidden = !isOpen;

        var list = document.createElement("ul");
        list.className = "bqa-lc-nav-list";

        module.lessons.forEach(function (lesson) {
          var item = document.createElement("li");
          var link = document.createElement("a");
          var published = lesson.published !== false;
          link.className = "bqa-lc-nav-link";
          link.dataset.lessonId = lesson.id;
          link.href = published ? lesson.url : "#";

          if (lesson.id === currentId) link.classList.add("is-current");
          if (progress[lesson.id]) link.classList.add("is-complete");

          if (!published) {
            link.classList.add("is-unpublished");
            link.setAttribute("aria-disabled", "true");
            link.addEventListener("click", function (event) { event.preventDefault(); });
          }

          var status = document.createElement("span");
          status.className = "bqa-lc-status-dot";
          status.setAttribute("aria-hidden", "true");

          var copy = document.createElement("span");
          copy.appendChild(document.createTextNode(lesson.title));

          if (!published) {
            var soon = document.createElement("span");
            soon.className = "bqa-lc-coming-soon";
            soon.textContent = "Coming soon";
            copy.appendChild(soon);
          }

          link.appendChild(status);
          link.appendChild(copy);
          item.appendChild(link);
          list.appendChild(item);
        });

        panel.appendChild(list);
        section.appendChild(toggle);
        section.appendChild(panel);
        nav.appendChild(section);

        toggle.addEventListener("click", function () {
          var expanded = toggle.getAttribute("aria-expanded") === "true";
          toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
          panel.hidden = expanded;
          moduleState[module.id] = !expanded;
          saveModuleState(moduleState);
        });
      });
    }

    function updateProgress() {
      var total = publishedLessons.length;
      var completed = publishedLessons.filter(function (lesson) { return !!progress[lesson.id]; }).length;
      var percent = total ? Math.round((completed / total) * 100) : 0;

      setText("bqa-lc-progress-label", completed + " of " + total + " lessons completed");
      setText("bqa-lc-progress-percent", percent + "% complete");
      setText("bqa-lc-drawer-progress", completed + " of " + total + " lessons complete");

      var currentModule = null;
var currentModuleNumber = 1;
var moduleLessonPosition = 1;
var moduleLessonTotal = 0;

if (currentLesson) {
  currentModuleNumber = currentLesson.moduleIndex + 1;
  currentModule = course.modules[currentLesson.moduleIndex];

  if (currentModule) {
    var modulePublishedLessons = currentModule.lessons.filter(function (lesson) {
      return lesson.published !== false;
    });

    moduleLessonTotal = modulePublishedLessons.length;

    var moduleLessonIndex = modulePublishedLessons.findIndex(function (lesson) {
      return lesson.id === currentId;
    });

    if (moduleLessonIndex >= 0) {
      moduleLessonPosition = moduleLessonIndex + 1;
    }
  }
}

setText(
  "bqa-lc-lesson-position",
  "Module " + currentModuleNumber +
  " · Lesson " + moduleLessonPosition +
  " of " + moduleLessonTotal
);

      var bar = byId("bqa-lc-progress-bar");
      var track = byId("bqa-lc-progress-track");
      if (bar) bar.style.width = percent + "%";
      if (track) track.setAttribute("aria-valuenow", String(percent));

      document.querySelectorAll(".bqa-lc-nav-link").forEach(function (link) {
        link.classList.toggle("is-complete", !!progress[link.dataset.lessonId]);
      });

      var button = byId("bqa-lc-complete-button");
      var heading = byId("bqa-lc-completion-heading");
      var copy = byId("bqa-lc-completion-copy");

      if (button && currentId) {
        var done = !!progress[currentId];
        button.classList.toggle("is-complete", done);
        button.textContent = done ? "✓ Lesson Completed" : "Mark Lesson Complete";
        if (heading) heading.textContent = done ? "Nice work—lesson completed" : "Mark this lesson complete";
        if (copy) copy.textContent = done ? "Your course progress has been updated." : "Your progress is saved in this browser.";
      }

      document.querySelectorAll(".bqa-lc-module").forEach(function (section, index) {
        var module = course.modules[index];
        var count = section.querySelector(".bqa-lc-module-count");
        if (count && module) count.textContent = moduleCompletedCount(module) + "/" + modulePublishedCount(module);
      });
    }

    function renderPrevNext() {
      var previous = currentIndex > 0 ? publishedLessons[currentIndex - 1] : null;
      var next = currentIndex >= 0 && currentIndex < publishedLessons.length - 1 ? publishedLessons[currentIndex + 1] : null;
      var prevLink = byId("bqa-lc-prev");
      var nextLink = byId("bqa-lc-next");

      if (prevLink) {
        if (previous) {
          prevLink.href = previous.url;
          setText("bqa-lc-prev-title", previous.title);
          setText("bqa-lc-prev-module", previous.moduleTitle);
          prevLink.classList.remove("is-hidden");
        } else {
          prevLink.classList.add("is-hidden");
        }
      }

      if (nextLink) {
        if (next) {
          nextLink.href = next.url;
          setText("bqa-lc-next-title", next.title);
          setText("bqa-lc-next-module", next.moduleTitle);
          nextLink.classList.remove("is-hidden");
        } else {
          nextLink.classList.add("is-hidden");
        }
      }
    }

    function openDrawer() {
      var drawer = byId("bqa-lc-course-drawer");
      var overlay = byId("bqa-lc-drawer-overlay");
      var button = byId("bqa-lc-menu-button");
      if (!drawer || !overlay) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      overlay.hidden = false;
      if (button) button.setAttribute("aria-expanded", "true");
      document.body.classList.add("bqa-lc-menu-open");
    }

    function closeDrawer() {
      var drawer = byId("bqa-lc-course-drawer");
      var overlay = byId("bqa-lc-drawer-overlay");
      var button = byId("bqa-lc-menu-button");
      if (!drawer || !overlay) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      overlay.hidden = true;
      if (button) button.setAttribute("aria-expanded", "false");
      document.body.classList.remove("bqa-lc-menu-open");
    }

    moveDrawerToBody();

    setText("bqa-lc-path-title", course.shortTitle || course.title);
    setText("bqa-lc-drawer-title", course.title);

    var brand = document.querySelector(".bqa-lc-sticky-brand");
    if (brand && course.landingUrl) brand.href = course.landingUrl;

    var home = byId("bqa-lc-course-home-link");
    if (home && course.landingUrl) home.href = course.landingUrl;

    if (currentLesson) {
      setText("bqa-lc-current-module", currentLesson.moduleTitle);
      setText("bqa-lc-mobile-module", currentLesson.moduleTitle);
      setText("bqa-lc-mobile-lesson", currentLesson.title);
    }

    renderCourseNavigation();
    renderPrevNext();
    updateProgress();

    var menuButton = byId("bqa-lc-menu-button");
    var closeButton = byId("bqa-lc-drawer-close");
    var overlay = byId("bqa-lc-drawer-overlay");
    var completeButton = byId("bqa-lc-complete-button");

    if (menuButton) menuButton.addEventListener("click", openDrawer);
    if (closeButton) closeButton.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);

    if (completeButton && currentId) {
      completeButton.addEventListener("click", function () {
        progress[currentId] = !progress[currentId];
        saveProgress(progress);
        updateProgress();
        renderCourseNavigation();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeDrawer();
    });
  });
})();